import { useState } from 'react';
import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';

import { useBuilderContext } from 'hb-builder/hooks';
import { getItem } from 'hb-react/shared/utils/sessionStorage';

import ModalContent from './ModalContent';

const SESSION_STORAGE_KEY = 'hivebrite-new-builder-confirmation-delete-modal';

const DeleteItemModal = ({ id, isDisabled, itemName, onConfirm }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { removeItem } = useBuilderContext();
  const handleCloseModal = () => setModalOpen(false);

  const userSkippedWarningModal = getItem({ key: SESSION_STORAGE_KEY });

  const deleteItem = (id) => {
    onConfirm?.();
    removeItem(id);
  };

  const handleOnClick = () =>
    userSkippedWarningModal ? deleteItem(id) : setModalOpen(true);

  const lowerItemName = itemName.toLowerCase();

  return (
    <>
      <DangerButton
        fontFamily="Inter"
        onClick={handleOnClick}
        isDisabled={isDisabled}
      >
        {__('Delete %{lowerItemName}').i__({ lowerItemName })}
      </DangerButton>
      {isModalOpen && (
        <ModalContent
          itemName={lowerItemName}
          closeModal={handleCloseModal}
          onConfirm={onConfirm}
          id={id}
        />
      )}
    </>
  );
};

export default DeleteItemModal;

// Remove this style when variant exist
const DangerButton = styled(Button)`
  background-color: #fd4329 !important;
  box-shadow: 0 2px 6px 0 rgb(250 92 124 / 50%);

  &:hover {
    background-color: #e43b24 !important;
    transition: background-color 200;
  }
`;
